import TrackedLink from 'components/sanity/TrackedLink';
import IconQuestionMark from '../../components/IconQuestionMark';
import { builtInLinks } from './navEvents';

interface HelpButtonProps {
  trackerClass: string;
}

const HelpButton = ({ trackerClass }: HelpButtonProps) => {
  return (
    <TrackedLink
      nav
      navItem={builtInLinks.help}
      href="/support"
      title="Help Page"
      className={`${trackerClass} ml-16 flex items-center bg-gray-light px-8 text-black no-underline transition hover:bg-white xs:ml-32 xs:px-16 lg-only:hidden`}
    >
      <div className="relative grid h-[20px] w-[20px] place-items-center rounded-[50%] border border-black">
        <IconQuestionMark />
      </div>
    </TrackedLink>
  );
};

export default HelpButton;
